const InvalidContent = () => {
  return (
    <div className="w-full py-32 text-center text-gray-500 underline">
      This content is not available for this account
    </div>
  );
};

export default InvalidContent;
